// For BoardMeeting Context
export const DASHBOARD_CONTEXT = 'DASHBOARD';
export const SET_BOARDMEETINGS = 'SET_BOARDMEETINGS';
export const SET_PAGINATED_BOARDMEETINGS = 'SET_PAGINATED_BOARDMEETINGS';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_PER_PAGE = 'SET_PER_PAGE';
export const SET_CUSTOM_PAGE = 'SET_CUSTOM_PAGE';
export const SET_FILTERS = "SET_FILTERS";
export const SET_LOADING = 'SET_LOADING';
